import dayjs from "dayjs";
import { SupportPlanBillableItemSids, SupportPlanStatus } from "../types";

export const mockActiveDeveloperSupport = {
  hasError: false,
  loading: false,
  otherPlansUrl: "",
  supportPlan: {
    billableItemSid: SupportPlanBillableItemSids.developer,
    friendlyName: "Developer Support",
    displayName: "Developer Support",
    description: "",
    shortDisplayName: "Developer",
    endDate: null,
    startDate: "2023-07-27",
    overview: "",
    phoneNumbers: [],
    price: 0,
    pricePercent: 0,
    status: SupportPlanStatus.active,
    level: {
      key: "developer",
      tag: "",
    },
  },
  pendingPlan: undefined,
};

export const mockDeveloperSupportWithTodayStartDay = {
  ...mockActiveDeveloperSupport,
  supportPlan: {
    ...mockActiveDeveloperSupport.supportPlan,
    startDate: dayjs(new Date()).format("YYYY-MM-DD"),
  },
};

export const mockDeveloperSupportWithPendingPlan = {
  ...mockActiveDeveloperSupport,
  pendingPlan: {
    billableItemSid: SupportPlanBillableItemSids.production,
    friendlyName: "Production Support",
    displayName: "Production Support",
    description: "",
    shortDisplayName: "Production",
    endDate: null,
    startDate: dayjs("2023-08-25").add(2, "day").format("YYYY-MM-DD"),
    overview: "",
    phoneNumbers: [],
    price: 0,
    pricePercent: 0,
    status: SupportPlanStatus.active,
    level: {
      key: "Production",
      tag: "",
    },
  },
};
